import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import FileUtil from "../../util/FileUtil";

import { FormattedMessage } from "react-intl";

class FileDropZone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      extensionError: null,
    };
  }

  onDrop(acceptedFiles, rejectedFiles) {
    this.setState({ extensionError: null });

    for (let file of acceptedFiles) {
      if (!FileUtil.extensionIsOk(file.name, this.props.acceptedExtensions)) {
        this.setState({
          extensionError: (
            <FormattedMessage
              id="Unsupported.File.Type.Ext"
              values={{ extension: FileUtil.extension(file.name) }}
            />
          ),
        });
        return;
      }
    }

    this.setState({ files: acceptedFiles });

    var clearFiles = () => {
      this.setState({ files: [] });
    };

    if (this.props.multiple) this.props.onDropFiles(acceptedFiles, clearFiles);
    else this.props.onDropFile(acceptedFiles[0], clearFiles);
  }

  render() {
    const baseStyle = {
      width: "100%",
      borderWidth: 2,
      borderColor: "#666",
      borderStyle: "dashed",
      borderRadius: 5,
      padding: 10,
    };
    const disabledStyle = { borderColor: "grey", color: "grey" };
    const activeStyle = {
      borderStyle: "solid",
      borderColor: "#6c6",
      backgroundColor: "#eee",
    };
    const rejectStyle = {
      borderColor: "#c66",
      color: "#c66",
      backgroundColor: "#eee",
    };

    return (
      <Dropzone
        disabled={this.props.disabled}
        onDrop={(acceptedFiles, rejectedFiles) =>
          this.onDrop(acceptedFiles, rejectedFiles)
        }
        multiple={this.props.multiple}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragAccept,
          isDragReject,
          acceptedFiles,
          rejectedFiles,
        }) => {
          let styles = { ...baseStyle };
          if (this.props.disabled) styles = { ...styles, ...disabledStyle };
          else {
            styles =
              isDragActive && isDragAccept
                ? { ...styles, ...activeStyle }
                : styles;
            styles =
              (isDragActive && isDragReject) || this.state.extensionError
                ? { ...styles, ...rejectStyle }
                : styles;
          }

          let filesNames = "";
          if (this.state.files.length <= 10) {
            for (let file of this.state.files) filesNames += " " + file.name;
            filesNames = <span>{filesNames}</span>;
          } else {
            var i = 0;
            for (; i < 10; i++) filesNames += " " + this.state.files[i].name;
            filesNames = (
              <span>
                {filesNames}...{" "}
                <small>
                  <em>
                    (
                    <FormattedMessage
                      id="More.items"
                      values={{ nbr: this.state.files.length - i }}
                    />
                    )
                  </em>
                </small>
              </span>
            );
          }

          let msg = null;
          if (this.state.extensionError) msg = this.state.extensionError;
          else if (isDragReject)
            msg = <FormattedMessage id="Unsupported.File.Type" />;
          else if (!this.props.multiple && this.state.files.length === 0)
            msg = <FormattedMessage id="Drag.Drop" />;
          else if (this.props.multiple && this.state.files.length === 0)
            msg = <FormattedMessage id="Drag.Drop.Multiple" />;
          else if (this.state.files.length > 0) msg = <div>{filesNames}</div>;

          return (
            <div {...getRootProps()} style={styles} className="text-center">
              <input {...getInputProps()} />
              <div>
                <i
                  className="fa fa-cloud-upload icon-giant d-block"
                  disabled={!this.props.multiple && this.state.files.length > 0}
                ></i>
                <div>{msg}</div>
              </div>
            </div>
          );
        }}
      </Dropzone>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileDropZone);
